var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2742 5.65521L11.2325 4.9225L8.9788 0.353458C8.91725 0.22836 8.81598 0.127091 8.69088 0.0655347C8.37714 -0.0893481 7.99589 0.0397209 7.83902 0.353458L5.58528 4.9225L0.543647 5.65521C0.40465 5.67507 0.277567 5.7406 0.180268 5.83988C0.0626403 5.96078 -0.00217811 6.12344 5.58887e-05 6.2921C0.00228988 6.46077 0.0713935 6.62165 0.192182 6.73939L3.83987 10.2957L2.97809 15.3175C2.95788 15.4343 2.97081 15.5545 3.0154 15.6643C3.06 15.7742 3.13448 15.8693 3.2304 15.939C3.32633 16.0087 3.43985 16.0501 3.5581 16.0585C3.67636 16.0669 3.7946 16.042 3.89944 15.9867L8.40891 13.6158L12.9184 15.9867C13.0415 16.0522 13.1845 16.0741 13.3215 16.0502C13.667 15.9907 13.8993 15.663 13.8397 15.3175L12.978 10.2957L16.6256 6.73939C16.7249 6.6421 16.7905 6.51501 16.8103 6.37602C16.8639 6.02852 16.6217 5.70684 16.2742 5.65521Z",
    fill: "url(#paint0_linear_1058_2469)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1058_2469",
    x1: 3.5037,
    y1: 12.7142,
    x2: 14.9688,
    y2: 2.82697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star_filled.ab42ba8c45418b7abd5404412640c8c1.svg";
export { ForwardRef as ReactComponent };